'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _stringify = require('babel-runtime/core-js/json/stringify');
var _stringify2 = _interopRequireDefault(_stringify);
var _lzString = require('lz-string');
var _lzString2 = _interopRequireDefault(_lzString);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function compress(input) {
  return _lzString2.default.compressToBase64(input).replace(/\+/g, '-') // Convert '+' to '-'
  .replace(/\//g, '_') // Convert '/' to '_'
  .replace(/=+$/, ''); // Remove ending '='
}

function getParameters(files) {
  return compress((0, _stringify2.default)(files));
}
exports.default = getParameters;